// Zet de platte QuestionnaireFields-lijst in weergavevolgorde: elke sectiekop
// direct gevolgd door zijn eigen vragen, op SectionPosition.
//
// De lijst wordt opgeslagen als één platte reeks waarin een vraag via
// `SectionID` naar zijn sectie wijst; Position zegt niets over waar een
// sectievraag staat. Elk scherm dat 'de volgorde' nodig heeft, moet die dus
// eerst weer opbouwen — dit is dat recept, één keer.
// AI-CONTEXT: See docs/pitfalls.md#dev-copied-recipe-instead-of-shared-hook

import groupFieldsBySection from './groupFieldsBySection'

/**
 * @param {Array<object>} fields - QuestionnaireFields van één vragenlijst, in
 *   Position-volgorde (sectiemarkeringen en vragen door elkaar).
 * @returns {Array<object>} Dezelfde velden, plat, in weergavevolgorde.
 */
const flattenFieldsInOrder = (fields) => groupFieldsBySection(fields)
    .flatMap((item) => (item.kind === 'section' ? [item.section, ...item.questions] : [item.question]))

export default flattenFieldsInOrder
